/**
 * @exports
 * @class Parser
 */
// @ts-ignore
import anime from 'animejs';

import { getAll } from '../../helpers/utilities';

export class Parser {

    /**
     * Renders the HTML strings as elements.
     * 
     * @public
     * @returns Element[]
     */
    public parse(elementStrings: string[]): Element[] {
        const elements: Element[] = [];
        const elem                = document.createElement('div');

        elementStrings.forEach(elementString => {
            elem.innerHTML = elementString;
            elements.push((elem.firstElementChild as Element).cloneNode(true) as Element);
            elem.innerHTML = '';
        });

        return elements;
    }


    /**
     * Inserts the elements into the page using the provided options.
     * 
     * @public
     * @returns void
     * @param elements The elements to insert
     * @param options The options on how to insert these new elements
     */
    public insert(elements: Element[], options: ContentLoaderOptions['insertOptions']): void {

        // Append
        if(options.type === 'append') {
            elements.forEach(element => {
                options.element.appendChild(element);
            });
        }

        // Insert before
        if(options.type === 'before') {
            elements.forEach(element => {
                (options.element.parentNode as Element).insertBefore(element, options.element);
            });
        }
    }


    /**
     * Removes the existing content from the block and then executes the callback method.
     * 
     * @public
     * @returns void
     * @param callback The method to call at the end
     */
    public clear(selector: string, container: Element, callback?: () => void): void {
        const items = getAll(selector, container) as Element[];

        if(items) {

            anime({
                scale: 0,
                duration: 1000,
                opacity: [1, 0],
                targets: items,
                easing: 'easeOutQuint',
                complete: () => {

                    // Remove the items
                    items.forEach(item => {
                        const parent = (item.parentNode as Element);
                        if(parent) parent.removeChild(item);
                    });

                    // Execute our callback
                    if(callback) callback();
                }
            });
        } else {
            if(callback) callback();
        }
    }
}
